import React, { useEffect, useState } from "react";
import _ from "lodash";



export default function UploadCommonModal({onSubmit,handleClose,title}:any) {
	const handleSubmit = (event: any) => {
		const file = event.target.files[0];
		onSubmit(file);
		handleClose();
	  };
	return (
		<>

					<div className="absolute fixed w-[1200px] mt-10 inset-0  z-50 flex flex-warp justify-center align-middle bg-op ">
						<div className=" my-2 mx-auto max-w-sm ">
							<div className="rounded-lg shadow-lg flex flex-col w-[900px] bg-white mt-10  h-[80vh] p-4 overflow-auto bg-scroll">
								<div className="flex items-start justify-between w-full border-b p-2">
									<div className="flex w-full flex-col items-start justify-between text-lg" >
										{title}
									</div>
									<div className="cursor-pointer mx-1">
										<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
									</div>
								</div>
								<div className="w-full flex flex-col p-1 ">
								<div className="flex items-center justify-center w-full">
    <label htmlFor="dropzone-file" className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100 ">
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
            <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
            </svg>
            <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to {title}</span> or drag and drop</p>
            <p className="text-xs text-gray-500">CSV, PDF, SVG, PNG, JPG or GIF </p>
        </div>
        <input id="dropzone-file" type="file" className="hidden"   onChange={(event) => handleSubmit(event)}/>
    </label>
</div>
								</div>
							</div>
						</div>
					</div >
		
		</>
	);
}